export enum UserRoleCode {
  systemAdminUserRole = 'SYSTEM_ADMINISTRATOR',
  clientAdminUserRole = 'CLIENT_ADMINISTRATOR',
  consilioUserRole = 'CONSILIO_USER',
  clientUserRole = 'CLIENT_USER',
}
